import { useEffect, useState } from '../../common/common';
import useGetUserData from '../../secureAPI/GetUserData';
import * as XLSX from 'xlsx';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import axiosJWT from '../../secureAPI/axiosJWT';
import { showToast } from '../../Utils/toastUtils';
import Navigations from '../../common/useNavigation';

const MidsellerBuyers = (type) => {
    const { users,userPlan,Remainuser,subUser } = useGetUserData();
    const { navigateDashboard } = Navigations();
    
    const [isLoading, setisLoading] = useState(false);
    const [seacrh, setSearch] = useState('');
    const [sheetdata, setSheetdata] = useState([]);
    const [filteredbuyers, setFilteredbuyers] = useState([]);
    const [buyers, setbuyers] = useState([]);
    useEffect(() => {
        //  console.log('called useeffectsss');
        if (Array.isArray(users) && users.length > 0) {
            //   console.log('useEffect called, users:', users);
            logUserData();
        }
    }, [users]);


    const logUserData = () => {
        if (users?.length > 0) {
            const userTypes = users[0]['UserType'];
            const usertypeArray = typeof userTypes === 'string' ? userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];
            // console.log({usertypeArray:usertypeArray});

            const hasOne = usertypeArray.includes(1);
            const hasTwo = usertypeArray.includes(2);
            if (type === 'seller' && users[0]['IsPersonalDetils'] === 1 && (hasOne && hasTwo)) {

            }
            else {
                navigateDashboard('seller');
            }
        }
    };
    useEffect(() => {
        getbuyers();
    }, []);

    const getbuyers = async () => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetAllSellersBuyers`, { app: 0 }, { withCredentials: true })
                .then((response) => {
                    StopLoading(setisLoading);
                    if (response.data.success === 1) {
                        setbuyers(response.data.data);
                        setFilteredbuyers(response.data.data);
                        setSheetdata(response.data.data);
                    }
                    else if (response.data.success === 0) {
                        StopLoading(setisLoading);
                        showToast(response.data.message, 'error');
                    }
                }).catch((err) => {
                    StopLoading(setisLoading);
                    showToast("Failed to find seller details, please try again later ", 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to find seller details, please try again later ", 'error');
        }
    }

    const exporttoExcelData = () => {
        var wb = XLSX.utils.book_new(),
            ws = XLSX.utils.json_to_sheet(sheetdata);
        XLSX.utils.book_append_sheet(wb, ws, 'Product Category');
        XLSX.writeFile(wb, "Selzor_Distributor_List.xlsx");
    }
    return { users,userPlan,Remainuser,subUser, seacrh, setSearch, exporttoExcelData, filteredbuyers, setFilteredbuyers, isLoading }
}

export default MidsellerBuyers